export var PlayerEventEnum;

!function(PlayerEventEnum) {
    PlayerEventEnum.change = "change", PlayerEventEnum.play = "play", PlayerEventEnum.pause = "pause", 
    PlayerEventEnum.backward = "backward", PlayerEventEnum.forward = "forward", PlayerEventEnum.end = "end", 
    PlayerEventEnum.OnChange = "change", PlayerEventEnum.OnPlay = "play", PlayerEventEnum.OnPause = "pause", 
    PlayerEventEnum.OnBackward = "backward", PlayerEventEnum.OnForward = "forward", 
    PlayerEventEnum.OnEnd = "end";
}(PlayerEventEnum || (PlayerEventEnum = {}));
//# sourceMappingURL=event.js.map
